// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2aYtg","itemTitle":"ClientEmergencyInfo_itemTitle___BEW_","itemText":"ClientEmergencyInfo_itemText__20B7-"};